var map = {
	"./Forme_1.png": 1637,
	"./Forme_3.png": 234,
	"./arrow-down.png": 1638,
	"./attente.png": 1639,
	"./barratio.jpeg": 1640,
	"./bell-alarm-symbol.png": 1641,
	"./bfast.png": 1642,
	"./bouteille.png": 521,
	"./burger.png": 522,
	"./checked.png": 228,
	"./clipboard.png": 1643,
	"./copied.png": 523,
	"./copy.png": 524,
	"./easilys.jpg": 1644,
	"./fleche rouge.png": 1645,
	"./gift-icon.png": 1646,
	"./gift_.png": 1647,
	"./gstock.png": 1648,
	"./guestonline.png": 1649,
	"./guestonline2.png": 1650,
	"./help.svg": 1651,
	"./illus-niveau1-partenaire.svg": 1652,
	"./info.png": 525,
	"./logo-text-white.png": 1653,
	"./logo.png": 1654,
	"./logo_plein.png": 518,
	"./logo_symbol.png": 192,
	"./netresto.jpg": 1655,
	"./netresto.png": 1656,
	"./nonintegrated.png": 230,
	"./pause.png": 229,
	"./ronds-confirmation-formulaire.svg": 519,
	"./snapshift.png": 1657,
	"./the_fork.png": 1658,
	"./userborder.svg": 233,
	"./validé.png": 1659,
	"./verre.png": 520,
	"./zenchef.png": 1660,
	"./zenchef2.jpg": 1661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 675;